import script from "./myUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./myUpload.vue?vue&type=script&lang=ts&setup=true"

import "./myUpload.vue?vue&type=style&index=0&id=63909102&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63909102"]])

export default __exports__